import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
} from '@lockerpm/design';

import {
  ArrowRightOutlined,
} from '@ant-design/icons';

import global from '../../config/global';

function DocLink(props) {
  const { className, docKey, title, showIcon = true } = props
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.userInfo);

  const linkUrl = useMemo(() => {
    return global.urls.DOC_LINKS[userInfo?.language || 'en'][docKey] || global.urls[docKey]
  }, [userInfo?.language, docKey])
  return <div
    className={`flex items-center text-primary cursor-pointer ${className}`}
    onClick={() => window.open(linkUrl, '_blank')}
  >
    <p className={ showIcon ? "mr-2" : ""}>{title}</p>
    {
      showIcon && <ArrowRightOutlined />
    }
  </div>
}

export default DocLink;
